const PRIMARY = "#742092";
const SECONDARY = "#C757B9";
const BG = "#FFC973";
const ACCENT = "#FFE3B3";
const BLACK = "#5A6470";
const WHITE = "#FFFFFF";

export {
    PRIMARY,
    SECONDARY,
    BG,
    ACCENT,
    BLACK,
    WHITE
}